const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const MS_PER_DAY = 24 * MS_PER_HOUR;

const pad2 = (value: number): string => value.toString().padStart(2, "0");

const pluralize = (value: number, unit: string): string =>
  `${value} ${unit}${value === 1 ? "" : "s"}`;

export type AdaptiveDuration = {
  display: string;
  tooltip: string;
};

export const formatAdaptiveDuration = (ms: number): AdaptiveDuration => {
  const totalMs = Number.isFinite(ms) ? Math.max(0, Math.floor(ms)) : 0;
  const totalSeconds = Math.floor(totalMs / MS_PER_SECOND);
  const days = Math.floor(totalMs / MS_PER_DAY);
  const hours = Math.floor((totalMs % MS_PER_DAY) / MS_PER_HOUR);
  const minutes = Math.floor((totalMs % MS_PER_HOUR) / MS_PER_MINUTE);
  const seconds = Math.floor((totalMs % MS_PER_MINUTE) / MS_PER_SECOND);

  const tooltipParts: string[] = [];
  if (days) tooltipParts.push(pluralize(days, "day"));
  if (hours) tooltipParts.push(pluralize(hours, "hour"));
  if (minutes) tooltipParts.push(pluralize(minutes, "minute"));
  if (seconds || tooltipParts.length === 0) {
    tooltipParts.push(pluralize(seconds, "second"));
  }

  let display: string;
  if (totalSeconds < 60) {
    display = `${seconds}S`;
  } else if (totalMs < MS_PER_HOUR) {
    display = `${minutes}M ${pad2(seconds)}S`;
  } else if (totalMs < MS_PER_DAY) {
    display = `${hours}H ${pad2(minutes)}M`;
  } else if (hours > 0) {
    display = `${days}d ${hours}H`;
  } else {
    display = `${days}d ${pad2(minutes)}M`;
  }

  return {
    display,
    tooltip: tooltipParts.join(", "),
  };
};
